// 랜딩 페이지, 카테고리 페이지간의 히어로 이펙트 키를 위한 모델입니다.

export default {
  img: key => `${key}_img`,
  caption: key => `${key}_caption`
};
